export default {
  questions: {
    openConversational: {
      openEndPlaceholder: "Bitte geben Sie hier Ihren Text ein",
      conversationalPlaceholder: "Bitte geben Sie hier Ihre Antwort ein",
      conversationClosed: "Unterhaltung beendet.",
      conversationalDisclaimer: "Folgefragen werden von KI basierend auf Ihren Antworten generiert."
    },
    openText: {
      openEndPlaceholder: "Bitte geben Sie hier Ihren Text ein"
    },
    multiText: {
      fieldPlaceholder: 'Antwort {number}',
      instruction: 'Geben Sie unten mindestens {count} Antwort ein, eine pro Textfeld | Geben Sie unten mindestens {count} Antworten ein, eine pro Textfeld',
      instructionWithoutMinimum: 'Geben Sie Ihre Antworten unten ein, eine pro Textfeld',
      minimumEntries: 'Bitte geben Sie mindestens {count} Antwort ein, um fortzufahren. | Bitte geben Sie mindestens {count} Antworten ein, um fortzufahren.',
      unaidedBrandAwareness: {
        fieldPlaceholder: 'Marke {number}',
        minimumEntries: 'Bitte geben Sie mindestens {count} Marke ein, um fortzufahren. | Bitte geben Sie mindestens {count} Marken ein, um fortzufahren.'
      }
    },
    multiselect: {
      caption: "Wählen Sie alle zutreffenden Optionen aus"
    },
    rankOrder: {
      enterRankOrder: "Reihenfolge eingeben",
      placeholder: "Ziehen Sie Ihre Auswahl hierher, um sie zu ordnen"
    },
    openNumeric: {
      label: "Offenes Zahlenfeld"
    },
    complete: {
      message: "Vielen Dank für das Ausfüllen dieser Umfrage."
    },
    openVideo: {
      warning: "Bitte nehmen Sie ein Video auf, bevor Sie fortfahren.",
      uploadStatusUploading: "Bitte warten Sie, bis wir Ihr Video verarbeitet haben, um fortzufahren...",
      uploadStatusSuccess: "Upload erfolgreich, Sie können fortfahren.",
      uploadStatusError: "Upload nicht abgeschlossen, bitte versuchen Sie es erneut."
    }
  },
  errors: {
    node: {
      text_invalid_email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
      text_invalid_phone: 'Bitte geben Sie eine gültige Telefonnummer ein',
      text_invalid_us_zip: 'Bitte geben Sie eine gültige US-Postleitzahl (ZIP) ein',
      text_invalid_ca_postal: 'Bitte geben Sie eine gültige kanadische Postleitzahl ein',
      text_invalid_uk_postal: 'Bitte geben Sie eine gültige britische Postleitzahl ein',
      text_invalid_custom: 'Bitte geben Sie einen gültigen {fieldName} ein',
      text_min_chars: 'Bitte geben Sie mindestens {min} Zeichen ein',
      text_max_chars: 'Bitte geben Sie höchstens {max} Zeichen ein',
      text_alpha_not_allowed: 'Nur Ziffern sind erlaubt',
      text_numeric_not_allowed: 'Nur Buchstaben sind erlaubt'
    },
    external: {
      invalid: 'Die Antwort auf diese Frage ist ungültig.',
      required: 'Diese Frage muss beantwortet werden.',
      singlechoice_required: 'Bitte wählen Sie eine Option aus, bevor Sie fortfahren.',
      numeric_required: 'Bitte wählen Sie eine Bewertung aus, bevor Sie fortfahren.',
      text_required: 'Bitte geben Sie eine Antwort ein, bevor Sie fortfahren.',
      bigtext_required: 'Bitte geben Sie eine Antwort ein, bevor Sie fortfahren.',
      singlechoiceother_incomplete: 'Bitte geben Sie eine Antwort ein, bevor Sie fortfahren.',
      multiselectother_incomplete: 'Bitte geben Sie eine Antwort ein, bevor Sie fortfahren.',
      numeric_invalid: 'Bitte geben Sie eine gültige Zahl ein, bevor Sie fortfahren.',
      radiogrid_required: 'Bitte wählen Sie für jede Zeile eine Option aus, bevor Sie fortfahren.',
      incomplete: 'Beantworten Sie diese Frage vollständig, bevor Sie fortfahren.',
      multiselect_min: 'Bitte wählen Sie mindestens {value} Optionen aus, bevor Sie fortfahren.',
      multiselect_max: 'Bitte wählen Sie nicht mehr als {value} Optionen aus, bevor Sie fortfahren.',
      multiselectother_min: 'Bitte wählen Sie mindestens {value} Optionen aus, bevor Sie fortfahren.',
      multiselectother_max: 'Bitte wählen Sie nicht mehr als {value} Optionen aus, bevor Sie fortfahren.',
      multiselectgrid_min: 'Bitte wählen Sie mindestens {value} Optionen für jede Zeile aus, bevor Sie fortfahren.',
      multiselectgrid_max: 'Bitte wählen Sie nicht mehr als {value} Optionen für jede Zeile aus, bevor Sie fortfahren.',
      rankorder_min: 'Bitte bewerten Sie mindestens {value} Elemente, bevor Sie fortfahren.',
      rankorder_max: 'Bitte bewerten Sie nicht mehr als {value} Elemente, bevor Sie fortfahren.'
    }
  }
}
